import { confirmAlert } from 'react-confirm-alert';
import '../styles/react-confirm-alert.css';

export const ConfirmAlert = (obj) => {
    confirmAlert(obj);
}